import './App.css';
import 'antd/dist/antd.css';
import { Card, Col, Divider, Layout, Menu, Row, Spin, Avatar, message, Popconfirm, Tag, Typography, Tooltip } from 'antd';
import { FaCarCrash, FaDownload } from 'react-icons/fa';
import { BiPowerOff } from 'react-icons/bi';
import logo from './images/swan-logo.svg';
import { Input, Button } from 'antd';
import CardContent from './components/CardContent';
import axios from 'axios';
import { Component } from 'react';
import LoginForm from './components/LoginForm';
import JSEncrypt from 'jsencrypt';
import PUBLIC_KEY from './keys/authpublickey.key.pub';

const jsEncrypt = new JSEncrypt();
fetch(PUBLIC_KEY)
  .then(key => key.text())
  .then(PUBLIC_KEY => {
    jsEncrypt.setPublicKey(PUBLIC_KEY);
  })
const { Header, Content, Sider } = Layout;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      regNo: '',
      policyNo: '',
      username: '',
      result: {},
      agency: '',
      loadingWholePage: true,
      loading: false,
      loadingLoginBtn: false,
      loadingExcel: false,
      token: '',
      isLoggedIn: false
    }
  }

  async componentDidMount() {
    await this.setState({
      loadingWholePage: true
    })
    if (window.localStorage.getItem('depannage-token')) {
      await this.verifyToken(window.localStorage.getItem('depannage-token'))
    }
    await this.setState({
      loadingWholePage: false
    })
  }

  handleInputRegNo = async (event) => {
    if (!(/^\s/.test(event.target.value))) {
      await this.setState({
        regNo: event.target.value
      })
    }
  }

  handleInputPolicyNo = async (event) => {
    if (!(/^\s/.test(event.target.value))) {
      await this.setState({
        policyNo: event.target.value
      })
    }
  }

  querySearch = async (e) => {
    if (this.state.isSmallView) {
      e.target.blur();
    }
    await this.setState({
      loading: true
    })
    if (window.localStorage.getItem('depannage-token')) {
      if (await this.verifyToken(window.localStorage.getItem('depannage-token')) === true) {
        await axios({
          method: 'POST',
          url: process.env.REACT_APP_API + '/api/fetch/search-results/',
          data: {
            regNo: this.state.regNo.replace(/ /g, '').replace(/\./g, ''),
            policyNo: this.state.policyNo,
            agency: this.state.agency
          }
        }).then(response => {
          this.setState({
            result: response.data.searchResults,
            loading: false
          })
        })
      } else {
        this.logout()
        message.error('Session timed out! Kindly login again')
      }
    } else {
      this.logout()
    }
  }

  clearSearch = async () => {
    this.setState({
      policyNo: '',
      regNo: '',
      result: {}
    })
  }

  validateLogin = async (values) => {
    await this.setState({
      loadingLoginBtn: true
    })
    await axios({
      method: 'POST',
      url: process.env.REACT_APP_API + '/api/fetch/user/',
      data: {
        data: jsEncrypt.encrypt(JSON.stringify({
          paramSrc: "WEBLIVE",
          username: values.username,
          password: values.password
        })).toString(),
      }
    }).then(async response => {
      if (response.data.IsValid === true) {
        await this.generateToken(response)
        await this.verifyToken(window.localStorage.getItem('depannage-token'))
        message.success('Successfully Logged in')
      } else {
        message.error('Authentication failed')
        this.logout()
      }
    })
    await this.setState({
      loadingLoginBtn: false
    })
  }

  generateToken = async (response) => {
    // CALL API TO CREATE JWT
    await axios({
      method: 'POST',
      url: process.env.REACT_APP_API + '/api/fetch/generateToken/',
      data: {
        data: response.data
      }
    }).then(response => {
      window.localStorage.setItem('depannage-token', response.data)
    })
  }

  downloadExcelAAA = async () => {
    await this.setState({
      loadingExcel: true
    })
    const response = await fetch(process.env.REACT_APP_API + '/api/fetch/allVehiclesAAA/', {
      method: 'POST',
      // headers: { 'Content-Type': 'application/json' },
      // body: JSON.stringify({ ...filters })
    });

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'AAA_Vehicles_Report.xlsx';
    a.click();
    await this.setState({
      loadingExcel: false
    })

  };

  downloadExcelADA = async () => {
    await this.setState({
      loadingExcel: true
    })
    const response = await fetch(process.env.REACT_APP_API + '/api/fetch/allVehiclesADA/', {
      method: 'POST',
      // headers: { 'Content-Type': 'application/json' },
      // body: JSON.stringify({ ...filters })
    });

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'ADA_Vehicles_Report.xlsx';
    a.click();
    await this.setState({
      loadingExcel: false
    })

  };

  logout = async () => {
    window.localStorage.removeItem('depannage-token')
    await this.setState({
      regNo: '',
      policyNo: '',
      username: '',
      result: {},
      loading: false,
      loadingLoginBtn: false,
      isLoggedIn: false
    })
  }

  verifyToken = async (token) => {
    await axios({
      method: 'POST',
      url: process.env.REACT_APP_API + '/api/fetch/verifyToken/',
      data: {
        data: token
      }
    }).then(response => {
      if (response.data.isValid === true) {
        this.setState({
          isLoggedIn: true,
          username: response.data.username,
          agency: response.data.agency
        })
      } else {
        this.logout()
      }
    })
    return this.state.isLoggedIn
  }

  render() {
    return (
      <div>
        {this.state.loadingWholePage ?
          <div className='loading' style={{ minHeight: '100vh', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Spin size='large' />
          </div>
          :
          <div className="App">
            {this.state.isLoggedIn ?
              <Layout style={{ height: '100%', minHeight: '100vh' }}>
                <Sider
                  style={!this.state.isSmallView ? { paddingLeft: '20px' } : null}
                  breakpoint="lg"
                  collapsedWidth="0"
                  onBreakpoint={broken => {
                    // console.log(broken);
                  }}
                  onCollapse={(collapsed, type) => {
                    if (collapsed === true) {
                      this.setState({
                        isSmallView: true
                      })
                    } else {
                      this.setState({
                        isSmallView: false
                      })
                    }
                    // console.log(collapsed, type);
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'center', marginBottom: '30px', flexDirection: 'column' }}>
                    <a href='.' style={{ color: 'white' }}>
                      <img alt="SWAN" src={logo} height={25} style={{ marginTop: '16px' }} />
                      <Divider style={{ background: 'transparent', marginBottom: 0, margin: 5 }} />
                      <span style={{ color: 'white' }}>Breakdown Service Portal</span>
                    </a>
                  </div>

                  <Menu mode="inline" defaultSelectedKeys={['1']}>
                    <Menu.Item key="1" icon={<FaCarCrash size={20} />}>
                      Breakdown
                    </Menu.Item>
                  </Menu>
                  {/* <Divider style={{ height: '3px' }} /> */}
                </Sider>
                <Layout className='content-layout'>
                  <Header className="site-layout-sub-header-background" style={{ padding: 0, height: 'auto' }} >
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        {this.state.isSmallView ?
                          <div style={{ marginTop: '5px' }}>
                            <img alt="SWAN" src={logo} style={{ marginLeft: '43px', height: 'calc(3vh + 2vmin)' }} />
                            <Divider type='vertical' style={{ background: 'white', height: '30px', marginLeft: '15px', marginRight: '15px', marginTop: '2px' }} />
                            <span style={{ color: 'white' }}>Breakdown Service Portal</span>
                          </div>
                          :
                          null
                        }

                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                        <Avatar style={{ background: '#DAFBFF' }} >
                          <span style={{ color: 'darkblue' }}>{this.state.username.substring(0, 2)}</span>
                        </Avatar>
                        <span style={{ color: 'white', marginLeft: '15px' }}>{this.state.username}</span>
                        <Divider type='vertical' />
                        <Popconfirm
                          placement="bottomRight"
                          title='Are you sure you want to log out?'
                          onConfirm={() => { this.logout(); message.success('Logged out!') }}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button
                            className='logout-btn'
                            style={{ color: 'white' }}
                            type='link'
                            icon={<BiPowerOff style={{ fontSize: '24px' }} />}
                            size='large'
                          />
                        </Popconfirm>
                      </Col>
                    </Row>
                  </Header>
                  <Content style={!this.state.isSmallView ?
                    { padding: '15px 46px 0', borderRadius: '2px 0 0 0', background: '#f0f2f5' }
                    :
                    { padding: '15px 46px 0', borderRadius: 0, background: '#f0f2f5' }
                  }>
                    <div className="site-layout-background">
                      <h1>Policies</h1>
                    </div>
                    <div className='search-form' style={{ background: 'white', width: '100%', height: 'auto', padding: '10px', borderRadius: 3 }}>
                      <Row gutter={8}>
                        <Col xs={24} sm={24} md={4} lg={3}>
                          <p style={{ margin: '10px' }}>
                            Policy Number
                          </p>
                        </Col>
                        <Col xs={22} sm={22} md={18} lg={7}>
                          <Input
                            value={this.state.policyNo}
                            placeholder="Enter policy number"
                            style={{ margin: '10px', borderRadius: 3 }}
                            autoFocus
                            onPressEnter={this.state.policyNo || this.state.regNo ? this.querySearch : null}
                            onChange={this.handleInputPolicyNo}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={2}></Col>
                        <Col xs={24} sm={24} md={4} lg={3}>
                          <p style={{ margin: '10px' }}>
                            Reg No.
                          </p>
                        </Col>
                        <Col xs={22} sm={22} md={18} lg={7}>
                          <Input
                            value={this.state.regNo}
                            placeholder="Enter Reg No."
                            style={{ margin: '10px', borderRadius: 3 }}
                            onPressEnter={this.state.policyNo || this.state.regNo ? this.querySearch : null}
                            onChange={this.handleInputRegNo}
                          />
                        </Col>
                        <Divider />
                        <Col xs={10} style={{ textAlign: 'left' }}>
                          {this.state.username.startsWith('AAA') ?
                            <Tooltip title='Extract AAA Logs'>
                              <Button
                                onClick={() => this.downloadExcelAAA()}
                                type='link'
                                loading={this.state.loadingExcel}
                                icon={<FaDownload />}
                              />
                            </Tooltip>
                            :
                            this.state.username.startsWith('ADA') ?
                              <Tooltip title='Extract ADA Logs'>
                                <Button
                                  onClick={() => this.downloadExcelADA()}
                                  type='link'
                                  loading={this.state.loadingExcel}
                                  icon={<FaDownload />}
                                />
                              </Tooltip>
                              :
                              null
                          }

                        </Col>
                        <Col xs={12} style={{ textAlign: 'right' }}>
                          <Button
                            type="link"
                            onClick={this.clearSearch}
                          >
                            Clear Search
                          </Button>
                          <Button
                            onClick={this.querySearch}
                            loading={this.state.loading}
                            type='primary'
                            disabled={this.state.regNo || this.state.policyNo ? false : true}
                          >
                            Search</Button>
                        </Col>
                      </Row>
                    </div>
                    {this.state.loading ?
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
                        <Spin size="large" />
                      </div>
                      :
                      <div className='search-results' style={{ marginTop: '20px', borderRadius: 3 }}>
                        <div className="site-card-wrapper">
                          {this.state.result && Object.keys(this.state.result).length !== 0 ?
                            <Row gutter={16} style={{ marginBottom: '10px' }}>
                              <Col xs={24} sm={24} md={24} lg={24}>
                                <Card title={
                                  <Row>
                                    <Col>
                                      <Typography>
                                        Motor Details
                                      </Typography>
                                    </Col>
                                    <Col>
                                      <Tag color='blue' style={{ marginLeft: 10 }}>
                                        {this.state.result.BRSPROVIDR?.replaceAll(' ', '')}
                                      </Tag>
                                    </Col>
                                  </Row>
                                } hoverable bordered={false}>
                                  <Row>
                                    <Col lg={8} md={24} sm={24} xs={24}>
                                      <CardContent title='Has Depannage?' description={this.state.result.DEPANNAGE} />
                                      <CardContent title='Policy Status' description={this.state.result.POLICYSTATUS} />
                                      <CardContent title='Reg No.' description={this.state.result.REGNO} />
                                    </Col>
                                    <Col lg={8} md={24} sm={24} xs={24}>
                                      <CardContent title='Client Name' description={this.state.result.CLIENTNAME} />
                                      <CardContent title='Policy No.' description={this.state.result.POLICYNUM} />
                                      <CardContent title='Make and Model' description={this.state.result.MODEL} />
                                    </Col>
                                    <Col lg={8} md={24} sm={24} xs={24}>
                                      <CardContent title='Start date' description={this.state.result.DATEFROM} />
                                      <CardContent title='End date' description={this.state.result.DATETO} />
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            </Row>
                            :
                            <h1>
                              No Results
                            </h1>
                          }
                        </div>
                      </div>
                    }
                  </Content>
                  {/* <Footer styleFf={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer> */}
                </Layout>
              </Layout>


              :
              <LoginForm
                {...this.state}
                validateLogin={this.validateLogin.bind(this)}
              />
            }
            {/* <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer> */}



          </div>
        }



      </div>



    );
  }
}

export default App;
